import { useCallback } from 'react';
import jwt_decode from 'jwt-decode';

import { AVAILABLE_COMPANIES, AVAILABLE_LANGUAGES } from 'constants/user';

import { isDefined, isFieldDefined } from 'services/util/auxiliaryUtils';

import { useUserStore } from 'stores/user';

import type { TUser } from 'types/user';

// The token the SSO sign-in puts in the URL. Its user's locale is compared as it comes (the sign-in form reads
// `locale.locale` from the same field).
type TRedirectToken = {
    user: Omit<TUser, 'locale'> & { locale: unknown };
    sessionIndex?: string;
};

const useRedirectToken = () => {
    const { switchLanguage, setUser } = useUserStore((state) => state.actions);

    /** Signs in with the token in the URL, when there is one, and says whether there was. */
    const isValidRedirectToken = useCallback(
        (searchParams: URLSearchParams) => {
            const token = searchParams.get('token');
            if (!isFieldDefined(token)) {
                return false;
            }

            localStorage.setItem('userToken', token);
            const jwtDecodeToken = jwt_decode<TRedirectToken>(token);
            localStorage.setItem('uadfs', String(isDefined(jwtDecodeToken?.sessionIndex)));
            const lngObj = AVAILABLE_LANGUAGES.find((obj) => obj.locale === jwtDecodeToken.user.locale) ?? AVAILABLE_LANGUAGES[0];
            const companyName = AVAILABLE_COMPANIES.find((company) => company.id === jwtDecodeToken.user.company_id)?.name;
            switchLanguage(lngObj);
            setUser({
                ...jwtDecodeToken.user,
                companyName,
                auth: {
                    isRequesting: false,
                    isUserAuthenticated: true,
                    showPassword: false,
                },
            } as TUser);

            return true;
        },
        [switchLanguage, setUser]
    );

    return { isValidRedirectToken };
};

export default useRedirectToken;
